module.exports = __webpack_public_path__ + "img/OKIS-J-6.7eb73bb0.svg";